import extractParams from './extractParams';
import makeQueryString from './makeQueryString';
import splitUrl from './splitUrl';

import { Params } from './types';

/**
 * Takes an `adjust` function that defines how to handle params from a URL's
 * querystring and returns the transformed URL.
 *
 * Ensures we remove the `?` if there are no query params in the adjusted URL.
 */
const adjustUrlParams = (
  adjust: (params: Params) => Params | null,
  url: string
) => {
  const parts = splitUrl(url);
  const newParams = adjust(extractParams(url)) || {};
  const newUrl = `${parts.baseHref}?${makeQueryString(newParams)}`;
  // Strip trailing `?` if there are no params
  return newUrl.replace(/\?$/, '');
};

export default adjustUrlParams;
